import { message } from "antd"
import { RcFile } from "antd/lib/upload/interface"

export const checkIsUploadableImage = (file: RcFile, maxSize?: number, imagesOnly?: boolean) => {
  const isSVG = file.type.includes("image/svg")
  const isJPG = file.type === "image/jpeg"
  const isPng = file.type === "image/png"
  const isVideo = file.type.includes("video")

  if (!isJPG && !isPng && !isSVG && !isVideo) {
    message.error("You can only upload JPG or PNG  or SVG file!")

    return false
  }

  if (imagesOnly && isVideo) {
    message.error("You can only upload JPG, PNG or SVG here, not a video!")

    return false
  }

  const maxImageSize = maxSize || 2
  const isSizeValid = file.size / 1024 / 1024 < maxImageSize
  if (!isSizeValid) {
    message.error(`Image must be smaller than ${maxImageSize}MB!`)

    return false
  }

  return true
}

export const checkIsUploadableSound = (file: RcFile, maxSize?: number) => {
  const isMP3 = file.type === "audio/mpeg" || file.type === "audio/mp3"
  const isWAV = file.type === "audio/wav" || file.type === "audio/wave"
  const isOGG = file.type === "audio/ogg"
  const isAAC = file.type === "audio/aac"

  if (!isMP3 && !isWAV && !isOGG && !isAAC) {
    message.error("You can only upload MP3, WAV, OGG, or AAC audio files!")

    return false
  }

  const maxSoundSize = maxSize || 5
  const isSizeValid = file.size / 1024 / 1024 < maxSoundSize
  if (!isSizeValid) {
    message.error(`Audio file must be smaller than ${maxSoundSize}MB!`)

    return false
  }

  return true
}
